// extracted by mini-css-extract-plugin
export default {"swiper":"Perangkat_swiper__jVHqF","swiper-slide":"Perangkat_swiper-slide__Askxy","swiper-container":"Perangkat_swiper-container__17dus"};